import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/core/services/auth/auth.service';
import { Profile } from 'app/shared/models/profile.model';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DownloadService {
  static entityFactSheet = 'factsheet';
  static entityThematicFile = 'thematicFiles';
  static entityContest = 'contest';
  static entityNewspaperPdf = 'newspaperPdf';

  private base_url: string = environment.api_url;
  private pdf_url: string = environment.pdf_url;

  private fileGetUrl = '/download';
  private downloadCounter = '/download_counter';

  private token: string;
  private refresh_token: string;
  private profile: Profile;

  constructor(private authService: AuthService, private http: HttpClient) {}

  getMediaFile(mediaId: number, entity: string, newspaperSubname: string, profilId = 0, access_token = '', refresh_token = '', newspaperPdfDate = '', calameo: boolean = false) {
    let parameters = `media=${mediaId}&entity=${entity}&newspaperSubname=${newspaperSubname}`;
    if (entity === DownloadService.entityNewspaperPdf && !calameo) {
      parameters += '&forcePdf=1';
    }

    if (profilId) {
      parameters += `&profil=${profilId}`;
    }
    if (access_token) {
      parameters += `&access_token=${access_token}`;
    }
    if (refresh_token) {
      parameters += `&refresh_token=${refresh_token}`;
    }
    if (newspaperPdfDate) {
      parameters += `&newspaperPdfDate=${newspaperPdfDate}`;
    }
    if (calameo) {
      return `${this.base_url}${this.fileGetUrl}?${parameters}`;
    }

    window.open(`${this.base_url}${this.fileGetUrl}?${parameters}`, '_blank');
  }

  getPdfFromUrl(url, id) {
    this.http.get(`${this.base_url}${this.downloadCounter}?mediaId=${id}`).subscribe();
    window.open(url, '_blank');
  }

  sendPdfUrlToEmail(newspaper_subname: string, email: string): Observable<any> {
    return this.http.get(`${this.pdf_url}/download-free-pdf-popup?email=${email}&subname=${newspaper_subname}`).pipe(
      catchError(() => of({ send: false}))
    );
  }

  getFileToDownload(mediaId: number, entityName, newspaperSubname: string) {
    if (this.getProfileLoaded()) {
      return this.getMediaFile(
        mediaId,
        entityName,
        newspaperSubname,
        this.profile.profile_id,
        this.token,
        this.refresh_token
      );
    }
    return { errors: 'not_loggedin' };
  }

  getNewspaperPdfToDownload(mediaId: number, newspaperSubname: string, newspaperPdfDate: string, calameo: boolean = false) {
    if (this.getProfileLoaded()) {
      return this.getMediaFile(
        mediaId,
        DownloadService.entityNewspaperPdf,
        newspaperSubname,
        this.profile.profile_id,
        this.token,
        this.refresh_token,
        '',
        calameo
      );
    } else {
      return this.getMediaFile(
        mediaId,
        DownloadService.entityNewspaperPdf,
        newspaperSubname,
        0,
        '',
        '',
        newspaperPdfDate
      );
    }
  }

    /**
   * Get auth profile data, return true if user is authentificated, false otherwise
   * @returns {boolean}
   */
  private getProfileLoaded(): boolean {
    if (this.authService.authenticated) {
      this.token = this.authService.accessToken;
      this.refresh_token = this.authService.refreshToken;
      this.profile = this.authService.activeProfile;
      return true;
    }
    return false;
  }
}
